class AhNewArrivals extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
      }, {rootMargin:'300px'});
      this.observer.observe(this);
    } else this.load();
  }
  disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
  async load() {
    const status = this.querySelector('[data-ah-arrivals-status]');
    this.setAttribute('aria-busy', 'true');
    status.textContent = 'Chargement des dernières créations…';
    const timer = setTimeout(() => this.controller.abort(), 10000);
    try {
      const url = new URL(this.dataset.url, location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid origin');
      const response = await fetch(url, {signal:this.controller.signal});
      if (!response.ok) throw new Error('Section unavailable');
      const markup = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-ah-latest-feed]');
      if (!markup) throw new Error('Missing section');
      // The response is first-party Shopify Liquid markup; no external HTML source is accepted.
      this.querySelector('[data-ah-arrivals]').replaceChildren(markup);
      status.textContent = markup.children.length ? '' : 'Aucune création disponible dans cette collection.';
    } catch {
      if (this.isConnected) status.textContent = 'Les nouveautés ne peuvent pas être chargées. Le lien « Toutes les nouveautés » reste disponible.';
    } finally { clearTimeout(timer); this.removeAttribute('aria-busy'); }
  }
}
customElements.define('ah-new-arrivals', AhNewArrivals);
